export default __webpack_public_path__ + "static/media/today-orders.1273472e.svg";